import request from '@/utils/request'

export function updateChessSkinCfg(data) {
  return request({
    url: 'api/v1/chess-skin/updateChessSkinCfg',
    method: 'post',
    data: data
  })
}

export function exportChessSkinCfg() {
  return request({
    url: 'api/v1/chess-skin/export',
    method: 'get' })
}

export function importChessSkinCfg(data) {
  return request({
    url: 'api/v1/chess-skin/import',
    method: 'post',
    data: data
  }
  )
}

export function getChessSkinList(data) {
  return request({
    url: 'api/v1/chess-skin/getChessSkinCfg',
    method: 'post',
    data: data
  })
}

export function delChessSkinCfg(data) {
  return request({
    url: 'api/v1/chess-skin/delChessSkinCfg',
    method: 'post',
    data: data
  })
}
